import { ApiCommonResponse } from "api/ApiCommonResponse";
import ApiService from "api/ApiService";
import { AdminReferral } from "models/admin/AdminReferral";

type GetReferralResponse = ApiCommonResponse & {
  referrals?: AdminReferral[];
};

type GetReferralExists = {
  exists: boolean;
};

export default class AdminService {
  private static getAdminUrl(): string {
    return "api/admin";
  }

  public static async adminReferralExists(
    code: string,
  ): Promise<GetReferralExists> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAdminUrl()}/referral/exists`,
          method: "POST",
          data: {
            code,
          },
        },
        false,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async getAdminReferrals(): Promise<GetReferralResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAdminUrl()}/referral`,
          method: "GET",
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async createAdminReferral(
    label: string,
    code: string,
    mail_to: string,
  ): Promise<ApiCommonResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAdminUrl()}/referral`,
          method: "POST",
          data: {
            label,
            code,
            mail_to,
          },
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async deleteAdminReferral(
    referral_id: number,
  ): Promise<ApiCommonResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAdminUrl()}/referral/${referral_id}`,
          method: "DELETE",
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
